import styled from 'styled-components';

import { flex } from '../../assets/styles/flex-grid';
import { SCREEN } from '../../assets/styles/constants';

import { YambWrapper } from '../modules/Yamb/components/Yamb.atoms';
import {
	DesktopHeaderHeight,
	MobileHeaderHeight,
} from '../modules/Yamb/Molecules/GameHeader/GameHeader.Atoms';
import {
	hoverEffects, margin, padding, textAlign,
} from '../../assets/styles/props';

export const BaseWrapper = styled.div`
	width: 100%;
	background-color: #ffffff;
	padding: 78px 25px 0px 25px;
	margin-bottom: 40px;
	${SCREEN.MEDIUM} {
		padding-top: 58px;
	}
`;
export const GameLayoutBaseWrapper = styled.div`
	width: 100%;
	background-color: #ffffff;
	padding-top: 10px;
	margin-top: ${DesktopHeaderHeight};
	${SCREEN.SMALL} {
		margin-top: ${MobileHeaderHeight};
	}
`;

export const BasicWrapper = styled.div`
	width: 100%;
	position: relative;
	overflow: hidden;
	${props => (props.background ? 'background: #fafafa' : '')};
	${props => (props.top ? 'padding: 85px 40px 120px 40px;' : 'padding: 120px 40px;')};
	${props => (props.main ? 'min-height: 75vh' : '')};

	display: flex;
	justify-content: center;

	${props => (props.notop ? 'padding-top: 0px;' : '')};

	${SCREEN.MEDIUM} {
		padding: unset;
		${props => (props.nobottom ? 'padding-bottom: 0px;' : '')};
	}
`;

export const MaxWidthWrapper = styled.div`
	max-width: 1600px;
	width: 100%;
	${props => (props.center ? 'text-align: center' : '')};
`;

// Images Wrapper
export const ImageWrapper = styled.div`
	max-width: 500px;
	width: 100%;
`;
// Social Media
export const SocialMediaIconWrapper = styled.div`
	width: 33px;
	opacity: 0.8;
	border-radius: 50%;
	&:hover {
		opacity: 1;
	}
`;
export const SocialMediaWrapper = styled.div`
	${flex};
	justify-content: space-between;
	max-width: 140px;
	width: 100%;
`;

export const CheckListWrapper = styled.div`
	max-width: 700px;
	margin: auto;
`;

export const CrewWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-flow: row wrap;
	justify-content: space-evenly;
	align-items: center;
	margin-top: -2px;

	${SCREEN.MEDIUM} {
		width: 90%;
		margin: 0 auto;
	}
`;

export const FullScreenWrapper = styled.div`
	display: block;
	background-color: #fafafa;
	width: 100%;
	overflow: visible;
	margin-bottom: 150px;
	${props => props.isFullScreen && 'padding: 0 40px; height: 100%; overflow: auto;'};
	${SCREEN.MEDIUM} {
		${YambWrapper} {
			${props => props.isFullScreen && 'margin-top: 60px;'};
		}
	}
	${SCREEN.MEDIUM} {
		padding: 0;
		${props => props.isFullScreen && 'padding: 0 0 150px;overflow: auto;'};
	}
`;

export const FullScreenContentWrapper = styled.div`
	height: 100%;
	display: flex;
	max-width: 1600px;
	margin: 0 auto;
	justify-content: center;
	flex-direction: column;
	${SCREEN.MEDIUM} {
		height: unset;
	}
`;

export const FullScreenButtonWrapper = styled.div`
	margin-top: 10px;
	margin-right: 60px;
	z-index: 2;
	${SCREEN.MEDIUM} {
		display: none;
		margin-right: 0;
		button {
			margin: 5px 0;
			border: 1px solid #7f84ff;
		}
	}
`;

export const MobileOpponentStatusWrapper = styled.div`
	display: none;
	${SCREEN.MEDIUM} {
		position: fixed;
		z-index: 12;
		left: 0;
		right: 0;
		top: 300px;
		display: block;
	}
`;

export const MobileTableHeaderWrapper = styled.div`
	display: none;

	${SCREEN.MEDIUM} {
		display: flex;
		justify-content: space-between;
		width: 100%;
		align-items: center;
		margin-bottom: 5px;
		padding: 0 5px;
		svg {
			color: #7f84ff;
		}
		button {
			padding: unset;
		}
	}
`;
export const HideMobile = styled.div`
	display: block;
	${SCREEN.SMALL} {
		display: none;
	}
`;
export const HideTablet = styled.div`
	display: block;
	height: 100%;

	${SCREEN.MEDIUM} {
		display: none;
	}
`;

export const HideMobileFlex = styled.div`
	display: flex;
	min-height: 34px;
	justify-content: center;
	${SCREEN.SMALL} {
		display: none;
	}
`;
export const ShowOnMobile = styled.div`
	display: none;
	${SCREEN.SMALL} {
		display: block;
	}
`;

export const ShowOnTablet = styled.div`
	display: none;
	${SCREEN.MEDIUM} {
		display: block;
	}
`;

export const Wrapper = styled.div`
	${hoverEffects};
	${padding};
	${margin};
	${textAlign};
	width: 100%;
	height: 100%;
`;
